module.exports = __webpack_public_path__ + "img/edit.eea9f56b.svg";